import { NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { IconModule } from '@shared/icon/icon.module';
import {
  CrmImportProgressService,
  type FloatingImportProgress,
} from '../../../core/services/crm-import-progress/crm-import-progress.service';

@Component({
  selector: 'app-import-progress-toast',
  standalone: true,
  imports: [NgIf, NgFor, IconModule],
  templateUrl: './import-progress-toast.component.html',
  styleUrls: ['./import-progress-toast.component.css'],
})
export class ImportProgressToastComponent {
  readonly progress = inject(CrmImportProgressService);

  trackByImportId(_index: number, item: FloatingImportProgress): string {
    return item.importId;
  }

  dismiss(importId: string): void {
    this.progress.dismiss(importId);
  }

  percent(item: FloatingImportProgress): number {
    return this.progress.progressPercent(item);
  }
}
